import React, { useEffect, useRef, useState } from "react";
import Image from "components/image";
import getContainerSizeClass from "@root/helpers/get-container-size-class";
import VisualSearch from "../header/visual-search";

const ImageBannerSearch = ({ data }) => {
    const classes = getContainerSizeClass(data?.moduleSettings);
    const height = data?.height;
    const visualSearchAnchorRef = useRef(null);
    const visualSearchRef = useRef(null);
    const [isVisualSearchFixed, setIsVisualSearchFixed] = useState(false);
    const [visualSearchHeight, setVisualSearchHeight] = useState(0);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const updateVisualSearchState = () => {
            const anchorElement = visualSearchAnchorRef.current;
            const visualSearchElement = visualSearchRef.current;
            if (!anchorElement || !visualSearchElement) return;

            const anchorTop = anchorElement.getBoundingClientRect().top;
            setIsVisualSearchFixed(anchorTop <= 0);
            setVisualSearchHeight(visualSearchElement.offsetHeight || 0);
        };

        updateVisualSearchState();
        window.addEventListener("scroll", updateVisualSearchState, { passive: true });
        window.addEventListener("resize", updateVisualSearchState);

        return () => {
            window.removeEventListener("scroll", updateVisualSearchState);
            window.removeEventListener("resize", updateVisualSearchState);
        };
    }, []);

    return (
        <div
            className={`image-banner image-banner-search ${data?.tabletImage?.asset ? "image-banner--has-tablet" : ""} ${classes.join(" ")}`}
            style={{ "--height": `${height}px`, marginTop: classes.join(" ").includes('wide') ? -16 : 0 }}
        >
            <div ref={visualSearchAnchorRef} />
            <div
                ref={visualSearchRef}
                className={`image-banner-search__visual-search ${isVisualSearchFixed ? "image-banner-search__visual-search--fixed" : ""}`}
            >
                <VisualSearch />
            </div>
            {isVisualSearchFixed && (
                <div
                    className="image-banner-search__visual-search-placeholder"
                    style={{ height: `${visualSearchHeight}px` }}
                />
            )}
            <div className="image-banner__desktop-image">
                <Image
                    className="image-banner__image"
                    image={data?.desktopImage}
                    to={data?.url}
                    width={false}
                    style={{ objectFit: "cover" }}
                    removeSrcset={true}
                />
            </div>
            {data?.tabletImage?.asset && (
                <div className="image-banner__tablet-image">
                    <Image
                        className="image-banner__image"
                        image={data?.tabletImage}
                        to={data?.url}
                        style={{ objectFit: "cover" }}
                    />
                </div>
            )}
            <div className="image-banner__mobile-image">
                <Image
                    className="image-banner__image"
                    image={data?.mobileImage}
                    to={data?.url}
                    style={{ objectFit: "cover" }}
                />
            </div>
        </div>
    );
};

export default ImageBannerSearch;